// actions.js
import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  DELETE_PRODUCTS_REQUEST,
  DELETE_PRODUCTS_FAILURE,
  DELETE_PRODUCTS_SUCCESS,
  FETCH_PRODUCT_REQUEST,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
  UPDATE_PRODUCTS_REQUEST,
  UPDATE_PRODUCTS_SUCCESS,
  UPDATE_PRODUCTS_FAILURE,
  OPEN_EDIT_PAGE_PRODUCT,
  OPEN_EDIT_PAGE_PRODUCT_SUCCESS,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_PRODUCT_SUCCESS,
} from './actionTypes';

export const fetchProductsRequest = () => ({
  type: FETCH_PRODUCTS_REQUEST,
});

export const fetchProductsSuccess = (projects) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: projects,
});

export const fetchProductsFailure = (error) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: error,
});

export const fetchProductRequest = (id) => ({
  type: FETCH_PRODUCT_REQUEST,
  payload: id
});

export const fetchProductSuccess = (project) => ({
  type: FETCH_PRODUCT_SUCCESS,
  payload: project,
});

export const fetchProductFailure = (error) => ({
  type: FETCH_PRODUCT_FAILURE,
  payload: error,
});

export const updateProductRequest = (product, navigate, config) => {
  return {
  type: UPDATE_PRODUCTS_REQUEST,
  payload: { product, navigate, config }
}};

export const updateProductSuccess = () => ({
  type: UPDATE_PRODUCTS_SUCCESS,
});

export const updateProductFailure = (error) => ({
  type: UPDATE_PRODUCTS_FAILURE,
  payload: error,
});

export const deleteProductRequest = (id) => ({
  type: DELETE_PRODUCTS_REQUEST,
  payload: id
});

export const deleteProductSuccess = (id) => ({
  type: DELETE_PRODUCTS_SUCCESS,
  payload: id,
});

export const deleteProductFailure = (error) => ({
  type: DELETE_PRODUCTS_FAILURE,
  payload: error,
});

export const openEditPageProduct = (id, navigate) => ({
  type: OPEN_EDIT_PAGE_PRODUCT,
  payload: { id, navigate }
});

export const openEditPageProductSuccess = () => ({
  type: OPEN_EDIT_PAGE_PRODUCT_SUCCESS,
});

export const clearProductErrors = () => ({
  type: CLEAR_PRODUCT_ERRORS,
});

export const clearProductSuccess = () => ({
  type: CLEAR_PRODUCT_SUCCESS,
});
